var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 2.33325C7.57427 2.33325 2.33594 7.57158 2.33594 13.9999C2.33594 20.4283 7.57427 25.6666 14.0026 25.6666C20.4309 25.6666 25.6693 20.4283 25.6693 13.9999C25.6693 7.57158 20.4309 2.33325 14.0026 2.33325ZM19.5793 11.3166L12.9643 17.9316C12.8009 18.0949 12.5793 18.1883 12.3459 18.1883C12.1126 18.1883 11.8909 18.0949 11.7276 17.9316L8.42594 14.6299C8.0876 14.2916 8.0876 13.7316 8.42594 13.3933C8.76427 13.0549 9.32427 13.0549 9.6626 13.3933L12.3459 16.0766L18.3426 10.0799C18.6809 9.74159 19.2409 9.74159 19.5793 10.0799C19.9176 10.4183 19.9176 10.9666 19.5793 11.3166Z",
    fill: "#00A0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.b2a4af1b973985463963ffa327d4d2ab.svg";
export { ForwardRef as ReactComponent };